import React from 'react';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { ReviewItem } from '../Review/components/ReviewItem';

export const CharityNameReview = () => {
  const {
    workflow: {
      data: { charityName },
    },
  } = useCharitableGivingContext();

  return <ReviewItem label="Charity Name" value={charityName || '—'} />;
};
